
import React from 'react';

import { LuInfo } from "react-icons/lu";

import { tooltipClasses } from "@mui/material/Tooltip";

import { styled } from '@mui/material/styles';
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import IconButton from '@mui/material/IconButton';
import Box from "@mui/material/Box";


const BoxTooltipA = styled(({ className, ...props }) => (
    <Box
       


        {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
        maxWidth: 220,
    },
}));



function TempPreviewTimelineFilterTooltip() {

 

   


    return (
        <>

            <IconButton sx={{ mb: '-6.5VH' }}>
                <LuInfo />
            </IconButton>
            <Box sx={{
                backgroundColor: "#FFFFFF",
                color: 'rgba(0, 0, 0, 0.87)',
                width: "12VW",
                height: '10VH',
                mt: '-12.5VH',
                ml: '12.5VW',
                zIndex: 9999,
                borderRadius: '5%',
                fontSize: 11,
                maxWidth: 220,
                boxShadow: 1
            }}>
                <>
                    <div className="row-no-margin">

                    </div>

                    <div className="row-no-margin">
                        <Typography sx={{ zIndex: 10, mt: '0VH', mb: 0, ml: '1VW', mr: "0%", fontWeight: "600", }} textAlign="left" variant="h6" fontWeight="400" fontSize="14px" component="div">

                            Click directly on a timeline or use the Batch End Date filter to view data for a specific batch.


                        </Typography>

                    </div>

                    <div className="row-no-margin">

                    </div>


                </>
            </Box>
            <Box sx={{width: '25%', mb: 5}}>

            </Box>
               



           
        </>
    );
}

export default TempPreviewTimelineFilterTooltip;

